import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, mergeProps as _mergeProps, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "label"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "font-medium" }
const _hoisted_4 = {
  key: 1,
  class: "italic font-medium"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "font-medium" }
const _hoisted_7 = { class: "boxed search" }
const _hoisted_8 = { class: "flex flex-grow items-center" }
const _hoisted_9 = {
  key: 0,
  class: "all-toggle pl-5"
}
const _hoisted_10 = { class: "boxed" }
const _hoisted_11 = { class: "flex items-center justify-between" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 0,
  class: "mr-2"
}
const _hoisted_14 = {
  key: 0,
  class: "only-this"
}
const _hoisted_15 = ["onClick"]

import { computed, ref } from 'vue'
import { CheckIcon } from '@heroicons/vue/20/solid'

import SlideFadeTransition from '@/components/SlideFadeTransition.vue'
import Input from "@/components/Input.vue";

interface Option {
  key: string,
  label: string,
}


const __default__ = {
  inheritAttrs: false
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'Listbox',
  props: {
    label: {},
    options: {},
    multiple: { type: Boolean },
    maxOptionsInLabel: {},
    expand: { type: Boolean },
    marginless: { type: Boolean },
    floating: { type: Boolean },
    modelValue: {},
    showLabel: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const isExpanded = ref(props.expand || false);

const options = computed(() => props.options);

const selectedOptions = computed(() => {
  return Array.isArray(props.modelValue) ? props.modelValue : [props.modelValue]
});

function isOptionSelected(option: Option): boolean {
  return selectedOptions.value.map(option => option.key).includes(option.key);
}

function toggleOption(option: Option) {
  let selection = selectedOptions.value;
  if (props.multiple) {
    if (isOptionSelected(option)) {
      selection = selection.filter(opt => opt.key !== option.key);
    } else {
      selection.push(option);
    }
  } else {
    selection = [option];
    isExpanded.value = false;
    query.value = '';
  }

  emit('update:modelValue', props.multiple ? selection : selection[0]);
}

function selectOption(option: Option) {
  isExpanded.value = false;
  query.value = '';
  emit('update:modelValue', props.multiple ? [option] : option);
}

const query = ref('')
const filteredOptions = computed(() =>
    query.value === '' ? options.value : options.value.filter(option =>
        option.label
        .toLowerCase()
        .replace(/\s+/g, '')
        .includes(query.value.toLowerCase().replace(/\s+/g, ''))
    )
)

const selectedOptionLabels: string[] = computed(() => {
  let labels = selectedOptions.value.map(option => option.label).sort((optionA, optionB) => optionA.localeCompare(optionB));

  if (props.maxOptionsInLabel !== undefined && labels.length > props.maxOptionsInLabel) {
    labels = [`${labels.length} selected`];
  }

  return labels;
})

const isAllSelected = computed(() => selectedOptions.value.length === options.value.length);

function toggleAll() {
  if (isAllSelected.value) {
    emit('update:modelValue', []);
  } else {
    emit('update:modelValue', options.value);
  }
}

function onMouseLeave() {
  if (isExpanded.value) {
    isExpanded.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _directive_focus = _resolveDirective("focus")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.marginless ? '' : 'mb-2']),
    onMouseleave: onMouseLeave
  }, [
    (_ctx.showLabel)
      ? (_openBlock(), _createElementBlock("label", _hoisted_1, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _mergeProps({
      class: ['boxed preview', isExpanded.value ? 'is-expanded' : ''],
      onClick: _cache[0] || (_cache[0] = ($event: any) => (isExpanded.value = !isExpanded.value))
    }, _ctx.$attrs), [
      (_ctx.showLabel)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (selectedOptions.value.length > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                  _createElementVNode("span", _hoisted_3, _toDisplayString(selectedOptionLabels.value.join(', ')), 1)
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_4, "Nothing selected"))
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(_toDisplayString(_ctx.label), 1),
            (selectedOptions.value.length > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                  _cache[3] || (_cache[3] = _createTextVNode(": ")),
                  _createElementVNode("span", _hoisted_6, _toDisplayString(selectedOptionLabels.value.join(', ')), 1)
                ]))
              : _createCommentVNode("", true)
          ], 64))
    ], 16),
    _createVNode(SlideFadeTransition, null, {
      default: _withCtx(() => [
        (isExpanded.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(['options', _ctx.floating ? 'is-floating' : ''])
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _cache[4] || (_cache[4] = _createElementVNode("label", {
                    for: "query",
                    class: "sr-only"
                  }, "Search", -1)),
                  _withDirectives(_createElementVNode("input", {
                    label: "query",
                    id: "query",
                    name: "query",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((query).value = $event)),
                    autocomplete: "off",
                    placeholder: "Search ..."
                  }, null, 512), [
                    [_vModelText, query.value],
                    [_directive_focus]
                  ])
                ]),
                (_ctx.multiple)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("a", {
                        href: "#",
                        class: "default-anchor",
                        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (toggleAll()), ["prevent"]))
                      }, _toDisplayString(isAllSelected.value ? 'none' : 'all'), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredOptions.value, (option) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", {
                      class: "flex flex-grow items-center cursor-pointer",
                      onClick: ($event: any) => (toggleOption(option))
                    }, [
                      (isOptionSelected(option))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createVNode(_unref(CheckIcon), {
                              class: "h-5 w-5",
                              "aria-hidden": "true"
                            })
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", null, _toDisplayString(option.label), 1)
                    ], 8, _hoisted_12),
                    (_ctx.multiple)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _createElementVNode("a", {
                            href: "#",
                            class: "default-anchor",
                            onClick: _withModifiers(($event: any) => (selectOption(option)), ["prevent"])
                          }, "only", 8, _hoisted_15)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 256))
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 34))
}
}

})